import React from 'react';
import cx from 'classnames';
import { number } from 'prop-types';
import formatMinutesSeconds from 'helpers/formatMinutesSeconds';
import segmentStatus from 'propTypes/segmentStatus';

import styles from './time-display.scss';

export default function TimeDisplay({ value, status }) {
  return (
    <span className={cx(styles.main, styles[`status-${status}`])}>
      {formatMinutesSeconds(value, {
        useClockFormat: true,
      })}
    </span>
  );
}

TimeDisplay.propTypes = {
  value: number.isRequired,
  status: segmentStatus,
};



// WEBPACK FOOTER //
// ./src/components/TimeDisplay/index.js